const Apiurl = "https://bs.aalantechsoft.com:8031/api";

// const Apiurl = `http://${window.location.hostname}:8000/api`;

export default Apiurl;